import { call, options, params } from './helpers';

export const getContacts = (payload) =>
	call(`/beta/contacts${params(payload)}`);

export const searchContacts = (payload) =>
	call(`/beta/contacts/search${params(payload)}`);

export const addContact = (payload) =>
	call(`/beta/contacts`, options(payload, 'POST'));

export const getContact = ({ id }) => call(`/beta/contacts/${id}`);
export const updateContact = ({ id, ...payload }) =>
	call(`/beta/contacts/${id}`, options(payload, 'PUT'));

export const deleteContact = (id) =>
	call(`/beta/contacts/${id}`, options(null, 'DELETE'));
